'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const RestoreScrollPosition = () => {
  const pathname = usePathname();

  useEffect(() => {
    const container = document.getElementById('content-container');
    const savedPath = sessionStorage.getItem('prevPage');
    const scrollY = sessionStorage.getItem('scrollPosition');

    if (container && savedPath === pathname && scrollY) {
      container.scrollTo(0, parseInt(scrollY, 10));
      sessionStorage.removeItem('scrollPosition');
      sessionStorage.removeItem('prevPage');
    } else if (container) {
      container.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default RestoreScrollPosition;
